export enum WorkLocation {
    Office = 0,
    Home = 1,
    FieldWork = 2,
    Hybrid = 3,
}